import {useState} from "react";


const useForm = (props: string[]) => {

    const [fields, setFields] = useState(props.reduce((acc: {[key: string]: {value: string, error: boolean}}, key) => {
        acc[key] = {
            value: '',
            error: false
        }
        return acc
    }, {}))

    const setField = ({key, value}: { key: string, value: string }) => {
        const target = {...fields[key as keyof typeof fields]}
        target.value = value
        !!value && (target.error = false)

        setFields({
            ...fields,
            [key] : target
        })
    }

    const validateFields = () => {
        const tempFields = {...fields}
        let hasErrors = false
        Object.entries(fields).forEach(([key, field]) => {
            if(!field.value){
                tempFields[key].error = true
                hasErrors = true
            }
        })
        setFields(tempFields)
        return hasErrors
    }

    return {fields, setField, validateFields}
}

export default useForm
